import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddShipmentsDataComponent } from 'src/app/core/dialogs/add-shipments-data/add-shipments-data.component';
import { DeletePalletDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-pallet-dialog.component';
import { EditShipmentsDataComponent } from 'src/app/core/dialogs/edit-shipments-data/edit-shipments-data.component';
import { BtnCellRendererDetails } from 'src/app/core/grid/btn-cell-render-details';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { ShipmentsService } from 'src/app/service/document-control/shipments.service';
import { ExcelService } from 'src/app/service/excel.service';
import { ExportStateService } from 'src/app/service/export-state.service';
import { TooltipFieldComponent } from 'src/app/core/dialogs/tooltip-field/tooltip-field.component';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-shipments',
    templateUrl: './shipments.component.html',
    styleUrls: ['./shipments.component.scss'],
    standalone: false
})
export class ShipmentsComponent implements OnInit {
  gridApi: any;
  successMessage
  errorMessage
  columnDefs = [];
  rowData = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  context: any;
  isAccessible = false;
  freightTypeDropDown: any;
  shipmentTypeDropDown: any;
  supplierDropdown: any[];

  paginationPageSize: number = 20;
	setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]

  constructor(private readonly router: Router, public dialog: MatDialog, private readonly excelService: ExcelService, private readonly exportStateService: ExportStateService,
    private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly shipmentsService: ShipmentsService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    // this.checkRoles();
    this.columnDefs = [
      {
        headerName: "ID", field: "shipmentId", width: 200, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true,
      },
      {
        headerName: "SUPPLIER", field: "p_supplier", width: 300, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true
      },
      {
        headerName: "MODE", field: "shipmentType", width: 300, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true,
      },
      {
        headerName: "SHIP DATE", field: "shipmentDate", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 300, unSortIcon: true, sortable: true, comparator: this.dateComparator
      },
      {
        headerName: "TYPE", field: "freightType", width: 300, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', unSortIcon: true, sortable: true,
      },
      {
        headerName: "TOTAL PALLETS", field: "p_pallets", width: 300, cellStyle: this.cellStyling,
        cellRenderer: TooltipFieldComponent, cellRendererParams: (params: ICellRendererParams) =>
          this.formatToolTip(params.data),
      },
      {
        headerName: "TOTAL SETS", field: "p_sets", width: 300,
      },
      {
        headerName: "NET KG", field: "netWeight", width: 300, valueFormatter: this.isNullemptyPackagingKG
      },
      {
        headerName: "GROSS KG", field: "grossWeight", filter: 'agNumberColumnFilter', width: 300,
      },
      {
        headerName: "VALUE", field: "partValue", width: 400, valueFormatter: this.isNullemptyPackagingValue
      },
      {
        headerName: "DETAILS", field: "details", width: 200, cellRenderer: BtnCellRendererDetails
      },
      {
        headerName: "ACTIONS", field: "shipment_editdelete", width: 300, cellRenderer: BtnCellRendererEditDelete
      },
    ];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.shipmentsDropDownData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  isNullemptyPackagingKG(params) {
    if (params.data.netWeight == null) // NOSONAR
     { return 0;}
    return  params.data.netWeight
  }

  isNullemptyPackagingValue(params) {
    if (params.data.partValue == null) // NOSONAR
      {return 0;}
    return params.data.partValue
  }

  cellStyling(params) {
    if (Number(params.data.palletStatus) != 0) { // NOSONAR
      return { 'background-color': 'red', 'color': 'black' };
    }
    return {}
  }

  formatToolTip(params: any) {
    const first = params.palletCounts
    const lineBreak = true;
    const toolTipArray = [first];
    return { toolTipArray, lineBreak };
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }

  async shipmentsDropDownData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
  
    try {
      const suppliers = await this.shipmentsService.loadSupplierDropDown();
      if (suppliers?.length) {
        this.supplierDropdown = suppliers.map(el => ({
          supplier: el.supplier,
          value: el.description
        }));
      }
  
      const shipmentTypes = await this.shipmentsService.loadShipmentsTypeDropDown();
      if (shipmentTypes?.length) {
        this.shipmentTypeDropDown = shipmentTypes.map(el => ({
          description: el.description,
          shipmentTypeId: el.shipmentTypeId
        }));
      }
  
      const freightTypes = await this.shipmentsService.loadFreightTypeDropDown();
      if (freightTypes?.length) {
        this.freightTypeDropDown = freightTypes.map(el => ({
          description: el.description,
          freightTypeId: el.freightTypeId
        }));
      }
  
      
    } catch (err) {
      // Handle error gracefully here (optional: show a message to the user)
    } finally {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
    }
    this.refreshData();
  }
  

  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  refreshData() {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.shipmentsService.loadShipmentsData().subscribe(
      response => {
        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        if (this.displayRowData.length) {
					this.totalRecords = this.displayRowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      },
      _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        this.defaultRowData();
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  deleteTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      DeletePalletDialogComponent, {
      disableClose: true,
      width: 'max-content',
      data: {
        header: 'Are you sure you want to delete this Shipment?',
        description: "ID : " + data.shipmentId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == "ConfirmEvent") { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.shipmentsService.deleteShipments(data.shipmentId).subscribe(
          response => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.refreshData();
            }
          }, _error => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          })
      }
    }
    );

  }

  editTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      EditShipmentsDataComponent, {
      disableClose: true,
      width: '520px',
      data: {
        header: 'EDIT SHIPMENT',
        eventType: 'EDIT',
        shipmentId: data.shipmentId,
        supplier: data.p_supplier,
        shipmentType: data.shipmentTypeId,
        shipmentDate: data.shipmentDate,
        emptyPackagingKG: data.emptyPackagingKG,
        emptyPackagingValue: data.emptyPackagingValue,
        supplierDropdown: this.supplierDropdown,
        freightTypeDropDown: this.freightTypeDropDown,
        shipmentTypeDropDown: this.shipmentTypeDropDown
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR
        this.successMessage = this.constants.APIDataUpdated;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();
      }
    });
  }

  addShipments() {
    const dialogRef = this.dialog.open(
      AddShipmentsDataComponent, {
      disableClose: true,
      width: '900px',
      data: {
        header: 'ADD SHIPMENT',
        eventType: 'ADD',
        supplierDropdown: this.supplierDropdown,
        freightTypeDropDown: this.freightTypeDropDown,
        shipmentTypeDropDown: this.shipmentTypeDropDown
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR

        this.successMessage = "Shipments added successfully";
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();

      }
    });
  }

  detailsTemplateRow(data, _pagename) {
    if (data.shipmentId) {
      const shipmentId = data.shipmentId;
      localStorage.setItem('shipment-details', JSON.stringify(shipmentId));
      this.openRouteLevel('shipments/shipment-details')

    } else {
      this.errorMessage = "Error with shipment id.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }
  }

  onBtExport() {
    if (this.displayRowData?.length > 0) {
      const headers = ['ID', 'Supplier', 'Mode', 'Ship Date', 'Type', 'Total Pallets', 'Total Sets', 'Net KG', 'Gross KG', 'Value'];
      const exportData = [];
      let linkData = [];
      if (Object.keys(this.gridApi?.getFilterModel()).length > 0) {
        const rowData = []
        this.gridApi.forEachNodeAfterFilter(node => { rowData.push(node.data) });
        linkData = rowData;
      } else
        {linkData = this.displayRowData}
      linkData.forEach(e => {
        const obj = {
          shipmentId: e.shipmentId,
          supplier: e.p_supplier,
          mode: e.shipmentType,
          shipmentdate: e.shipmentDate,
          type: e.freightType,
          pallets: e.p_pallets,
          sets: e.p_sets,
          netWeight: e.emptyPackagingKG,
          grossWeight: e.grossWeight,
          value: e.emptyPackagingValue,
        };
        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'SHIPMENT -DATA', headers);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }

}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 10) { // NOSONAR
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}